import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 人脸录入统计
  getStudentFaceCount(params) {
    return http.get(URL.API_SCHOOL_STUDENT_FACE_COUNT, params)
  },
  // 班级下成员列表
  getUserClassMembers(params) {
    return http.get(URL.API_SCHOOL_USER_CLASS_MEMBERS, params)
  },
  // 查询子部门信息
  getUserSubDept(params) {
    return http.get(URL.API_SCHOOL_USER_DEPT_SUBDEPT, params)
  },
  // 人脸录入统计
  getUserFaceStatistic(params) {
    return http.get(URL.API_SCHOOL_USER_FACE_STATISTIC, params)
  },
  // 家庭成员列表
  getUserFamilyList(params) {
    return http.get(URL.API_SCHOOL_USER_FAMILY_LIST, params)
  },
  // 家长录入统计
  getCountGuardian(params) {
    return http.get(URL.API_SCHOOL_USER_COUNT_GUARDIAN, params)
  },
  // 职工身份录入统计
  getCountStaff(params) {
    return http.get(URL.API_SCHOOL_USER_IDENTITY_STAFF, params)
  },
  // 学生身份录入统计
  getCountStudent(params) {
    return http.get(URL.API_SCHOOL_USER_IDENTITY_STUDENT, params)
  },
  // 人员信息
  getSchoolUserInfo(params) {
    return http.get(URL.API_SCHOOL_USER_INFO, params)
  },
  // 创建沙盒
  sandBoxCreate(params) {
    return http.post(URL.API_SCHOOL_SANDBOX_ORGUSER_CREATE, params)
  },
  // 获取沙盒状态
  sandBoxStatus(params) {
    return http.post(URL.API_SANDBOX_STATUS, params)
  },
  // 查询节点信息
  sandBoxSubNodes(params) {
    return http.post(URL.API_SANDBOX_GET_SUBNODES, params)
  },
  getDeptMembers(params) {
    return http.get(URL.API_SCHOOL_USER_DEPT_MEMBERS, params)
  },
  getClassStudent(params) {
    return http.get(URL.API_SCHOOL_USER_CLASS_STUDENTS, params)
  },
  getClassGuardian(params) {
    return http.get(URL.API_SCHOOL_USER_CLASS_GUARDIAN, params)
  },
  // 创建家校通讯录沙盒
  createUserSandBox(params) {
    return http.post(URL.API_SCHOOL_SANDBOX_USER_CREATE, params)
  },
  searchOrgMember(params) {
    return http.get(URL.API_SEARCH_ORG_MEMBER, params)
  },
  // 修改教职工信息
  getUserNoticeList(params) {
    return http.post(URL.API_SCHOOL_USER_NOTICE_LIST, params)
  },
  // 查询学生详情
  getUserStudentInfo(params) {
    return http.get(URL.API_SCHOOL_USER_STUDENT_INFO, params)
  },
  // 保存身份信息
  postUserIdentity(params) {
    return http.post(URL.API_SCHOOL_USER_IDENTITY_SAVE, params)
  },

  // 查询学生信息接口
  attendanceGetStudentList(params) {
    return http.post(URL.API_SCHOOL_GET_STUDENT_LIST, params)
  },
  // 获取学生标签类型
  getStudentIdTypes(params) {
    return http.get(URL.API_GET_IDENTIFY_TYPE, params)
  }
}
